export default __webpack_public_path__ + "static/media/Convenios_on.c6fec17f.svg";